// @ts-nocheck
import { DashboardLayout } from "./Dashboard";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, Heart, Mail, Phone, Edit, Eye } from "lucide-react";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAuth } from "@/contexts/use-auth";
import { useOrg } from "@/contexts/useOrg";
import { useDebouncedInput } from "@/hooks/useDebouncedInput";
import { PhoneInput } from "@/components/ui/input-phone";
import AxiosInstance from "@/utils/AxiosInstance";
import { useGetData } from "@/hooks/useGetData";
import LoaderWrapper from "./LoaderWrapper";
import { HorizontalCardShimmer } from "@/components/Shimmer";
import RHFWrapper from "@/components/RHFWrapper";
import RhfInput from "@/components/rhfFields/RhfInput";
import Grid from "@/components/Grid";
import RhfPhone from "@/components/rhfFields/RhfPhone";
import RhfSelect from "@/components/rhfFields/RhfSelect";
import { caretakerInitalValues } from "@/utils/InitialValues";
import CommonFormFields from "@/components/CommonFormFields";
import {
  getErrToast,
  getPromise,
  getPromiseToast,
  trimmedObject,
} from "@/utils/helpers";
import {
  capitalizeTheStartingCharacterFilter,
  PERSON_CAPITALIZE_FIELDS,
} from "@/constants/payloadFilters";
import * as yup from "yup";
import { CaretakerSchema, CommonFieldSchema } from "@/utils/ValidataionSchemas";
import MyDialogContent from "@/components/MyDialogContent";
import { useFormContext, useWatch } from "react-hook-form";
import RhfChecked from "@/components/rhfFields/RhfChecked";
import TableWithSearch from "@/components/TableWithSearch";
import { caretakerTableHeaders } from "@/utils/tablesData";
import useRerender from "@/hooks/useRerender";
import { useNavigate } from "react-router";
// Dummy data for caretakers

export default function Caretakers() {
  const { selectedOrganizations, selectedOrgId, isAllSelected, allFacilities } =
    useOrg();
  const organizations = selectedOrganizations;
  const {
    input: search,
    setInput: setSearch,
    debouncedInput,
  } = useDebouncedInput("", 500);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedCaretaker, setSelectedCaretaker] = useState<any>(null);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const [selectedOrgs, setSelectedOrgs] = useState<string[]>([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const nav= useNavigate();

  const [rawCaretakers, setRawCaretakers] = useState([]);
  const { renderVal, handleRenderChange } = useRerender();

  const currentUser = { role: "admin" };
  const selectedOrganization = organizations?.find(
    (org: any) => org._id === selectedOrgId,
  );
  const handleCreateCaretaker = async (formData, methods) => {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      // e.preventDefault();
      // const formData = new FormData(e.currentTarget);
      if (selectedOrgs.length === 0) {
        toast.error("Please select at least one facility");
        return;
      }
      setBtnLoading(true);
      // TODO: Replace with actual API call to create caretaker
      // e.g., await fetchJSON('/api/caretakers', { method: 'POST', body: JSON.stringify({ firstName: ..., ... }) });
      // For simulation with dummy data:
      const newCaretaker = {
        // _id: Date.now().toString(),
        firstName: formData?.firstName,
        middleName: formData?.middleName,
        lastName: formData?.lastName,
        dateOfBirth: formData?.dateOfBirth,
        email: formData?.email,
        phone: formData?.phone,
        street: formData?.street,
        city: formData?.city,
        state: formData?.state,
        zipcode: formData?.zipcode,
        gender: formData?.gender,
        status: formData?.status,
        timezone: formData?.timezone,
        assignedOrganizations: selectedOrgs as any[],
        permissions: formData?.permissions,
        type: formData?.type,
      };
      console.log("NEW CARETAKER", newCaretaker, formData);
      const { data } = await AxiosInstance().post(
        "/caretakers",
        capitalizeTheStartingCharacterFilter(
          trimmedObject(newCaretaker),
          PERSON_CAPITALIZE_FIELDS,
        ),
      );

      setRawCaretakers((prev) => [data?.data, ...prev]);
      resolveFn("Caretaker added successfully");
      setIsDialogOpen(false);
      // handleRenderChange();

      setSelectedOrgs([]);
    } catch (error) {
      rejectFn(error);
      if (methods) {
        if (
          error?.response?.data?.message.includes("email") &&
          error?.response?.data?.message.includes("exist")
        )
          methods.setError("email", {
            message: 'Email Already Exists',
          });

        if (
          error?.response?.data?.message.includes("phone") &&
          error?.response?.data?.message.includes("exist")
        )
          methods.setError("phone", {
            message: 'Phone Number Already Exists', 
          });
      }
    } finally {
      setBtnLoading(false);
    }
    // e.currentTarget.reset();
  };
  const handleUpdateCaretaker = async (formData, methods) => {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      if (!selectedCaretaker) return;
      if (selectedOrgs.length === 0) {
        toast.error("Please select at least one facility");
        return;
      }

      setBtnLoading(true);
      const updatedCaretaker = {
        // _id: Date.now().toString(),

        firstName: formData?.firstName,
        middleName: formData?.middleName,
        lastName: formData?.lastName,
        dateOfBirth: formData?.dateOfBirth,
        email: formData?.email,
        phone: formData?.phone,
        street: formData?.street,
        city: formData?.city,
        state: formData?.state,
        zipcode: formData?.zipcode,
        gender: formData?.gender,
        status: formData?.status,
        timezone: formData?.timezone,
        assignedOrganizations: selectedOrgs as any[],
        permissions: formData?.permissions,
        type: formData?.type,
        ...(formData?.newCaretakers && formData?.newCaretakers?.length>0 && {newCaretakers : formData?.newCaretakers})
      };

      await AxiosInstance().put(
        "/caretakers/" + selectedCaretaker?._id,
        capitalizeTheStartingCharacterFilter(
          trimmedObject(updatedCaretaker),
          PERSON_CAPITALIZE_FIELDS,
        ),
      );
      console.log("NEW CARETAKER", updatedCaretaker, formData);


      setRawCaretakers((prev) =>
        prev.map((c: any) =>
          c._id === selectedCaretaker._id
            ? {
                ...c,
                ...updatedCaretaker,
              }
            : c,
        ),
      );
      resolveFn("Caretaker updated successfully");
      setIsViewDialogOpen(false);
      setSelectedCaretaker(null);
      setSelectedOrgs([]);
    } catch (error) {
      rejectFn(error);
      if (methods) {
        if (
          error?.response?.data?.message.includes("email") &&
          error?.response?.data?.message.includes("exist")
        )
          methods.setError("email", {
            message: 'Email Already Exists',
          });

        if (
          error?.response?.data?.message.includes("phone") &&
          error?.response?.data?.message.includes("exist")
        )
          methods.setError("phone", {
            message: 'Phone Number Already Exists',
          });
      }
    } finally {
      setBtnLoading(false);
    }
  };
  const handleViewCaretaker = (caretaker: any) => {
    setSelectedCaretaker(caretaker);
    setSelectedOrgs(caretaker.assignedOrganizations || []);
    setIsViewDialogOpen(true);
  };

  // const organizations = useQuery(api.organizations.list);
  return (
    <DashboardLayout activePage="/caretakers" rightcomponent= {<>    {currentUser?.role === "admin" && (
            <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
              <DialogTrigger asChild>
                <Button className="w-auto">
                  <Plus className="w-4 h-4" />
                   Caretaker
                </Button>
              </DialogTrigger>
              <MyDialogContent heading="Add New Caretaker">
                <CaretakerForm
                  isEdit={false}
                  defaultValues={caretakerInitalValues}
                  handleSubmit={handleCreateCaretaker}
                  organizations={organizations}
                  selectedOrgs={selectedOrgs}
                  setSelectedOrgs={setSelectedOrgs}
                  setIsDialogOpen={(isOpen) => {
                    setIsDialogOpen(isOpen);
                    setSelectedOrgs([]);
                  }}
                  className="space-y-6"
                  btnLoading={btnLoading}
                />
              </MyDialogContent>
            </Dialog>
          )}
    </>}>
      <div className="">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {/* <div>
            <h2 className="text-3xl font-bold tracking-tight">Caretakers</h2>
            <p className="text-muted-foreground mt-2">
              Manage Anthro Care caretakers
            </p>
          </div> */}
      
          <Dialog open={isViewDialogOpen} onOpenChange={setIsViewDialogOpen}>
            <MyDialogContent heading="Update Caretaker">
              {selectedCaretaker && (
                <CaretakerForm
                  isEdit={true}
                  defaultValues={selectedCaretaker}
                  handleSubmit={handleUpdateCaretaker}
                  organizations={organizations}
                  selectedOrgs={selectedOrgs}
                  setSelectedOrgs={setSelectedOrgs}
                  setIsDialogOpen={(isOpen) => {
                    setIsViewDialogOpen(isOpen);
                    setSelectedOrgs([]);
                  }}
                  className="space-y-6"
                  btnLoading={btnLoading}
                />
              )}
            </MyDialogContent>
          </Dialog>
        </div>

        <TableWithSearch
          fetchCondition={true}
          heading="Caretakers List"
          isIncludeSearch
          isColumnSelection
          columnPreferenceKey="caretakers-list"
          clickRow={() => {}}
          apiDataKey="caretakers"
          columnHeaders={caretakerTableHeaders}
          searchPlaceholder="Search Caretakers "
          url="/caretakers"
          params={{ orgId: selectedOrgId }}
          data={rawCaretakers}
          viewData={rawCaretakers.map((v) => {
            // Format type in capitalize case
            let formattedType = "";
            if (v?.type) {
              if (v.type === "facility") {
                formattedType = "Facility";
              } else if (v.type === "no_facility") {
                formattedType = "No Facility";
              } else if (v.type === "all") {
                formattedType = "Both";
              } else {
                // Fallback: capitalize first letter and replace underscores with spaces
                formattedType = v.type
                  .split("_")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(" ");
              }
            }
            
            return {
              ...v,
              firstName: `${v?.firstName || ""} ${v?.middleName || ""} ${v?.lastName || ""}`,
              address: [v?.street, v?.city, v?.state, v?.zipcode]
                .map((part) => String(part ?? "").trim())
                .filter(Boolean)
                .join(", "),
              type: formattedType,
              assignedOrganizations: (v?.assignedOrganizations || [])
                .map(
                  (item) =>
                    organizations.find((org) => org?._id === item)
                      ?.organizationName,
                )
                .filter(Boolean),
            };
          })}
          // rawCaretakers.map((care) =>
          // (
          //   {
          //     ...care,

          //  assignedOrganizations: care.assignedOrganizations.map(
          //     (aOrg) =>
          //       organizations.find((o) => o?._id == aOrg)?.organizationName ||
          //       " ",
          //   ),
          //   }
          // )
          // )
          setData={setRawCaretakers}
          isActionColumn
          handleAction={(data) => {
            handleViewCaretaker(data);
          }}
         moreActions={[
          {label: "View ",
            icon: <Eye/>,
            onClick: (data)=> {nav(data?._id, {state : {data}})},
            isShow: () => true

          }
         ]}
        />
      </div>
    </DashboardLayout>
  );
}

export const CaretakerForm = ({
  isEdit,
  handleSubmit,
  className,
  organizations,
  selectedOrgs,
  setSelectedOrgs,
  setIsDialogOpen,
  defaultValues,
  btnLoading,
}) => {
  // console.log(defaultValues);
  return (
    <RHFWrapper
      onSubmit={handleSubmit}
      className={className}
      initialValues={defaultValues}
      isValidate={true}
      validateSchema={yup.object({ ...CommonFieldSchema, ...CaretakerSchema })}
    >
      <CommonFormFields defaultValues={defaultValues} isEdit={true} />
      
       <div className="space-y-2">
        <OrgMultiSelect
          organizations={organizations}
          setSelectedOrgs={setSelectedOrgs}
          defaultValue={defaultValues?.assignedOrganizations || []}
          statusDefaultValue = {defaultValues?.status}
          allDefaultValues={defaultValues}
        />
        <p className="text-xs text-muted-foreground">
          Select one or more organizations to assign this caretaker to.
          Caretakers will have access to all selected organizations.
        </p>
      </div>
      <div className="space-y-2">
        <RhfSelect
          label="Type of Caretaker"
          name="type"
          required={true}
          defaultvalue={defaultValues?.type || ""}
          options={[
            { label: "Facility", value: "facility" },
            { label: "No Facility", value: "no_facility" },
            // { label: "both", value: "all" },
          ]}
        />
      </div>
     
      <div className="space-y-2">
        <RhfChecked
          options={[
            { label: "Can Add Patients", value: "canAddPatients" },
            // { label: "Can Add Nursing Notes", value: "CanAddNursingNotes" },
          ]}
          label="Patient's Permissions"
          name="permissions"
          multiple={true}
        />
      </div>
      <div className="flex justify-end gap-3  sticky bottom-0 w-full bg-white">
        <Button
          type="button"
          variant="outline"
          // disabled={!selectedOrgs.length }
          onClick={() => setIsDialogOpen(false)}
        >
          Cancel
        </Button>
       <SubmitBtn btnLoading={btnLoading} isEdit={isEdit}/>
      </div>
    </RHFWrapper>
  );
};

const SubmitBtn = ({btnLoading, isEdit})=> {
  const {formState : {isDirty, dirtyFields}} = useFormContext()
  return (
     <Button disabled={btnLoading || (!isDirty || !Object.keys(dirtyFields).length)} type="submit">
          {isEdit ? "Update" : "Add"} Caretaker
        </Button>
  )
}

const OrgMultiSelect = ({ organizations, setSelectedOrgs, statusDefaultValue, defaultValue ,allDefaultValues}) => {

    const {setValue} = useFormContext()
  const selectedorginform = useWatch({ name: "assignedOrganizations" });
  const caretakerNewStatus = useWatch({name : "status"});
  const isCaretakerActive = statusDefaultValue == 'active';
  const {selectedOrgId, isAllSelected} = useOrg()
  const [caretakersList, setCaretakersList] = useState(null);
  console.log({selectedorginform})
const {} = useGetData("/caretakers", {orgId :isAllSelected ? selectedorginform?.join(","): selectedOrgId}, false, isCaretakerActive && caretakerNewStatus == 'inactive' , (err, data)=> {
  if(data&& !err){
    setCaretakersList(data?.data?.caretakers?.filter(v=> v?._id!= allDefaultValues?._id )); // filter current caretaker
  }
})

  console.log({ caretakerNewStatus, isCaretakerActive})

  useEffect(() => {
    selectedorginform &&
      Array.isArray(selectedorginform) &&
      selectedorginform.length > 0 &&
      setSelectedOrgs(selectedorginform);
  }, [selectedorginform]);

  useEffect(()=> {
    setValue('newCaretakers', [])
  },[caretakerNewStatus])

  return (
    <div className="space-y-3">
      {caretakersList && caretakerNewStatus == 'inactive' &&   <RhfSelect
      label="New Caretaker for their patients"
      multiple={true}
      required={true}

      name="newCaretakers"
      options={caretakersList.map((org) => ({
        label: org?.firstName,
        value: org?._id,
      }))}
      />}
    <RhfSelect
      label="Assigned Organizations"
      multiple={true}
      required={true}
      defaultvalue={defaultValue}
      name="assignedOrganizations"
      options={organizations.map((org) => ({
        label: org?.organizationName,
        value: org?._id,
      }))}
      />
    
      </div>
    
  );
};

// <form onSubmit={handleSubmit} className="space-y-6">
//                 <div className="grid grid-cols-2 gap-4">
//                   <div className="space-y-2">
//                     <Label htmlFor="firstName">First Name</Label>
//                     <Input id="firstName" name="firstName" required />
//                   </div>
//                   <div className="space-y-2">
//                     <Label htmlFor="lastName">Last Name</Label>
//                     <Input id="lastName" name="lastName" required />
//                   </div>
//                 </div>
//                 <div className="space-y-2">
//                   <Label htmlFor="email">Email</Label>
//                   <Input id="email" name="email" type="email" required />
//                 </div>
//                 <div className="space-y-2">
//                   <Label htmlFor="phone">Phone</Label>
//                   <Input id="phone" name="phone" type="tel" required />
//                 </div>
//                 <div className="space-y-2">
//                   <Label htmlFor="status">Status</Label>
//                   <Select name="status" defaultValue="active" required>
//                     <SelectTrigger>
//                       <SelectValue />
//                     </SelectTrigger>
//                     <SelectContent>
//                       <SelectItem value="active">Active</SelectItem>
//                       <SelectItem value="inactive">Inactive</SelectItem>
//                     </SelectContent>
//                   </Select>
//                 </div>
//                 <div className="space-y-2">
//                   <Label htmlFor="assignedFacilities">
//                     Assigned Organizations & Facilities
//                   </Label>
//                   <div className="border rounded-md p-3 space-y-3 max-h-64 overflow-y-auto bg-muted/30">
//                     {organizations && organizations.length > 0 ? (
//                       organizations.map((org: any) => {
//                         const orgFacilities =org?.facilities
//                         if (orgFacilities?.length === 0 || !orgFacilities) return null;
//                         return (
//                           <div
//                             key={org._id}
//                             className="space-y-2 pb-3 last:pb-0"
//                           >
//                             <div className="font-bold text-sm text-primary border-b border-border pb-1.5">
//                               {org.name}
//                             </div>
//                             <div className="space-y-1.5">
//                               {orgFacilities.map((facility: any) => (
//                                 <div
//                                   key={facility._id}
//                                   className="flex items-center space-x-2 ml-4"
//                                 >
//                                   <input
//                                     type="checkbox"
//                                     id={`add-facility-${facility._id}`}
//                                     checked={selectedOrgs.includes(
//                                       facility._id,
//                                     )}
//                                     onChange={(e) => {
//                                       if (e.target.checked) {
//                                         setSelectedOrgs([
//                                           ...selectedOrgs,
//                                           facility._id,
//                                         ]);
//                                       } else {
//                                         setSelectedOrgs(
//                                           selectedOrgs.filter(
//                                             (id: string) =>
//                                               id !== facility._id,
//                                           ),
//                                         );
//                                       }
//                                     }}
//                                     className="h-4 w-4 rounded border-gray-300 cursor-pointer"
//                                   />
//                                   <label
//                                     htmlFor={`add-facility-${facility._id}`}
//                                     className="text-sm cursor-pointer hover:text-primary transition-colors"
//                                   >
//                                     {facility.name}
//                                   </label>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         );
//                       })
//                     ) : (
//                       <p className="text-sm text-muted-foreground">
//                         No organizations available
//                       </p>
//                     )}
//                   </div>
//                   <p className="text-xs text-muted-foreground">
//                     Select one or more facilities to assign this caretaker to.
//                     Caretakers will have access to all selected facilities.
//                   </p>
//                 </div>
//                 <div className="flex justify-end gap-3">
//                   <Button
//                     type="button"
//                     variant="outline"
//                     onClick={() => setIsDialogOpen(false)}
//                   >
//                     Cancel
//                   </Button>
//                   <Button type="submit">Add Caretaker</Button>
//                 </div>
//               </form>

//  <form onSubmit={handleUpdateCaretaker} className="space-y-6">
//               <div className="grid grid-cols-2 gap-4">
//                 <div className="space-y-2">
//                   <Label htmlFor="edit-firstName">First Name</Label>
//                   <Input
//                     id="edit-firstName"
//                     name="firstName"
//                     defaultValue={selectedCaretaker.firstName}
//                     required
//                   />
//                 </div>
//                 <div className="space-y-2">
//                   <Label htmlFor="edit-lastName">Last Name</Label>
//                   <Input
//                     id="edit-lastName"
//                     name="lastName"
//                     defaultValue={selectedCaretaker.lastName}
//                     required
//                   />
//                 </div>
//               </div>
//               <div className="space-y-2">
//                 <Label htmlFor="edit-email">Email</Label>
//                 <Input
//                   id="edit-email"
//                   name="email"
//                   type="email"
//                   defaultValue={selectedCaretaker.email}
//                   required
//                 />
//               </div>
//               <div className="space-y-2">
//                 <Label htmlFor="edit-phone">Phone</Label>
//                 <Input
//                   id="edit-phone"
//                   name="phone"
//                   type="tel"
//                   defaultValue={selectedCaretaker.phone}
//                   required
//                 />
//               </div>
//               <div className="space-y-2">
//                 <Label htmlFor="edit-status">Status</Label>
//                 <Select
//                   name="status"
//                   defaultValue={selectedCaretaker.status}
//                   required
//                 >
//                   <SelectTrigger>
//                     <SelectValue />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectItem value="active">Active</SelectItem>
//                     <SelectItem value="inactive">Inactive</SelectItem>
//                   </SelectContent>
//                 </Select>
//               </div>
//               <div className="space-y-2">
//                 <Label htmlFor="edit-assignedFacilities">
//                   Assigned Organizations & Facilities
//                 </Label>
//                 <div className="border rounded-md p-3 space-y-3 max-h-64 overflow-y-auto bg-muted/30">
//                   {organizations && organizations.length > 0 ? (
//                     organizations.map((org: any) => {
//                       const orgFacilities =
//                         allFacilities?.filter(
//                           (f: any) => f.organizationId === org._id,
//                         ) || [];
//                       if (orgFacilities.length === 0) return null;
//                       return (
//                         <div
//                           key={org._id}
//                           className="space-y-2 pb-3 last:pb-0"
//                         >
//                           <div className="font-bold text-sm text-primary border-b border-border pb-1.5">
//                             {org.name}
//                           </div>
//                           <div className="space-y-1.5">
//                             {orgFacilities.map((facility: any) => (
//                               <div
//                                 key={facility._id}
//                                 className="flex items-center space-x-2 ml-4"
//                               >
//                                 <input
//                                   type="checkbox"
//                                   id={`edit-facility-${facility._id}`}
//                                   checked={selectedOrgs.includes(
//                                     facility._id,
//                                   )}
//                                   onChange={(e) => {
//                                     if (e.target.checked) {
//                                       setSelectedOrgs([
//                                         ...selectedOrgs,
//                                         facility._id,
//                                       ]);
//                                     } else {
//                                       setSelectedOrgs(
//                                         selectedOrgs.filter(
//                                           (id: string) =>
//                                             id !== facility._id,
//                                         ),
//                                       );
//                                     }
//                                   }}
//                                   className="h-4 w-4 rounded border-gray-300 cursor-pointer"
//                                 />
//                                 <label
//                                   htmlFor={`edit-facility-${facility._id}`}
//                                   className="text-sm cursor-pointer hover:text-primary transition-colors"
//                                 >
//                                   {facility.name}
//                                 </label>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <p className="text-sm text-muted-foreground">
//                       No organizations available
//                     </p>
//                   )}
//                 </div>
//                 <p className="text-xs text-muted-foreground">
//                   Select one or more facilities to assign this caretaker to.
//                   Caretakers will have access to all selected facilities.
//                 </p>
//               </div>
//               <div className="flex justify-end gap-3">
//                 <Button
//                   type="button"
//                   variant="outline"
//                   onClick={() => {
//                     setIsViewDialogOpen(false);
//                     setSelectedCaretaker(null);
//                   }}
//                 >
//                   Cancel
//                 </Button>
//                 <Button type="submit">
//                   <Edit className="w-4 h-4 mr-2" />
//                   Update Caretaker
//                 </Button>
//               </div>
//             </form>

//  <Label htmlFor="assignedFacilities">
//       Assigned Organizations
//     </Label>
//     <div className="border rounded-md p-3 space-y-3 max-h-64 overflow-y-auto bg-muted/30">
//       {organizations && organizations.length > 0 ? (
//         organizations.map((org: any) => {

//           return (
//             <div key={org._id} className="space-y-2 ">
//               <div className="font-bold text-sm text-primary border-b border-border pb-1">
//               <div
//                     key={org?._id}
//                     className="flex items-center space-x-2 ml-4"
//                   >
//                     <input
//                       type="checkbox"
//                       id={`add-facility-${org._id}`}
//                       checked={selectedOrgs.includes(org._id)}
//                       onChange={(e) => {
//                         if (e.target.checked) {
//                           setSelectedOrgs([
//                             ...selectedOrgs,
//                             org._id,
//                           ]);
//                         } else {
//                           setSelectedOrgs(
//                             selectedOrgs.filter(
//                               (id: string) => id !== org._id,
//                             ),
//                           );
//                         }
//                       }}
//                       className="h-4 w-4 rounded border-gray-300 cursor-pointer"
//                     />
//                     <label
//                       htmlFor={`add-facility-${org?._id}`}
//                       className="text-sm cursor-pointer hover:text-primary transition-colors"
//                     >
//                     {org.name}
//                     </label>
//                   </div>
//               </div>

//             </div>
//           );
//         })
//       ) : (
//         <p className="text-sm text-muted-foreground">
//           No organizations available
//         </p>
//       )}
//     </div>
